import { render, staticRenderFns } from "./SessionChart.vue?vue&type=template&id=ff3e931c&scoped=true"
import script from "./SessionChart.js?vue&type=script&lang=js&external"
export * from "./SessionChart.js?vue&type=script&lang=js&external"
import style0 from "./SessionChart.vue?vue&type=style&index=0&id=ff3e931c&prod&lang=css"
import style1 from "./SessionChart.vue?vue&type=style&index=1&id=ff3e931c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff3e931c",
  null
  
)

export default component.exports